import { BrowserCacheLocation, Configuration } from '@azure/msal-browser';
import { environment } from '../../environments/environment';

const port = window.location.port ? `:${window.location.port}` : '';
const redirectUrl = `${window.location.protocol}//${window.location.hostname}${port}/auth-callback`;

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.MSAL_CLIENT_ID,
    authority: environment.MSAL_AUTHORITY,
    redirectUri: redirectUrl,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    loggerOptions: {
      // TODO: to review necessity of loggerOptions
      loggerCallback: () => {},
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};

// TODO: figure out the correct values for the scope
export const requestScopes = ['user.read'];
